// components/PermissionWrapper.js
import React, { useContext } from "react";
import { LoginContext } from "./LoginContext";
import ErrorPage from "../pages/ErrorPage";

const ProtectedComponent = ({ children, module, action }) => {
  const { hasPermission } = useContext(LoginContext);
  const permissionResult = hasPermission(module, action);

  if (permissionResult === null) {
    // Still loading
    return <div>Loading Permissions...</div>;
  }

  if (!permissionResult) {
    return <ErrorPage />;
  }

  return children;
};


export default ProtectedComponent;